import { SKUAPIService } from "./sku";
import api from "../index";

export default new SKUAPIService(api);
